import { variables } from '@bitrise/bitkit';
import * as d3Scale from 'd3-scale';

export const scaleZero = (zeroIndex: number, length: number): number =>
  zeroIndex / (length - 1) || 0;

export const colorScale1 = d3Scale
  .scaleLinear<string>()
  .range([variables.colorAqua1, variables.colorGrape1]);

export const colorScale2 = d3Scale
  .scaleLinear<string>()
  .range([variables.colorAqua2, variables.colorGrape2]);

export const colorScale3 = d3Scale
  .scaleLinear<string>()
  .range([variables.colorAqua3, variables.colorGrape3]);
